import { LaneData } from "components/CPCommittedCapacity/components/LaneWidget/LaneWidget";


export const getDropTrailerValue = (lane: LaneData) => {
  const dropTrailerString = [];
  if (lane?.dropAtShipper) {
    dropTrailerString.push("At Shipper")
  }
  if (lane?.dropAtConsignee) {
    dropTrailerString.push("At Consignee")
  }
  if (!dropTrailerString.length) {
    return "N/A"
  }
  return dropTrailerString.join(', ')
}

export const getLaneRequirements = (lane: LaneData) => {
  const requirements = [];

  if (lane?.isHazmat) {
    requirements.push('Hazmat')
  }

  if (lane?.isTeam) {
    requirements.push('Team')
  }

  if (lane?.isTankerEndorsement) {
    requirements.push('Tanker Endorsed')
  }

  if (!requirements.length) {
    return "N/A"
  }

  return requirements.join(', ')
}
